import script from "./complete.vue?vue&type=script&setup=true&lang=js"
export * from "./complete.vue?vue&type=script&setup=true&lang=js"

import "./complete.vue?vue&type=style&index=0&id=361cc3f0&lang=scss"

const __exports__ = script;

export default __exports__